<template>
  <div>
    <b-card>
      <div class="mb-4">
        <base-button
          icon
          type="primary"
          @click="handleClick('admin-coursesdetails')"
        >
          <span class="btn-inner--icon"><i class="ni ni-bold-left"></i></span>

          <span class="btn-inner--text">Back </span>
        </base-button>
      </div>
      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="selectedCourse.attendees"
      >
        <el-table-column label="Sr. No" type="index" min-width="130px" sortable>
        </el-table-column>

        <el-table-column
          label="Student Name"
          min-width="150px"
          prop="subtitle"
          sortable
        >
          <template v-slot="{ row }">
            <span class="text-black">{{
              row.userId
                ? row.userId.firstname
                  ? row.userId.firstname
                  : "" + " " + row.userId.lastname
                  ? row.userId.lastname
                  : ""
                : ""
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="	
            Learning Report"
          min-width="150px"
          prop="orderno"
          sortable
        >
          <template v-slot="{ row }">
            <span
              class="text-black"
              v-if="getTotalPercentage(row.userId.id) >= 100"
              >100%</span
            >
            <span class="text-black" v-else
              >{{ getTotalPercentage(row.userId.id) }}%</span
            >
            <span class="hidden">{{ getCompletedTopics(row.userId.id) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="Status"
          min-width="170px"
          prop="imgurl"
          sortable
        >
          <template v-slot="{ row }">
            <span
              class="text-black"
              v-if="getTotalPercentage(row.userId.id) <= 0"
              >Not Started</span
            ><span
              class="text-black"
              v-else-if="
                getTotalPercentage(row.userId.id) > 0 &&
                getTotalPercentage(row.userId.id) != 0 &&
                getTotalPercentage(row.userId.id) < 100
              "
              >Ongoing</span
            ><span class="text-black" v-else>Completed</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="this.selectedCourse.appr == false"
          label="Certificate"
          min-width="170px"
          prop="imgurl"
          sortable
          ><template v-slot="{ row }">
            <base-button
              class="px-4 py-1 mx-1 fsize10"
              type="primary"
              value="false"
              v-model="appr"
              @click="approves(row)"
              :disabled="row.approval.includes(selectedCourse._id)"
            >
              Approve
            </base-button>

            <base-button
              class="px-4 py-1 mx-1 fsize10"
              type="danger"
              value="false"
              v-model="appr"
              @click="reject(row)"
              :disabled="!row.approval.includes(selectedCourse._id)"
            >
              Reject
            </base-button>

            <!-- <div v-else>
              <base-button
                v-if="!row.approval.includes(selectedCourse._id)"
                class="px-4 py-1 mx-1"
                type="primary"
                value="false"
                v-model="appr"
                @click="approves(row)"
              >
                Approve
              </base-button>

              <base-button
                v-else-if="row.approval.includes(selectedCourse._id)"
                class="px-4 py-1 mx-1"
                type="danger"
                value="false"
                v-model="appr"
                @click="reject(row)"
              >
                Reject
              </base-button>
            </div> -->
          </template>
        </el-table-column>
        <el-table-column
          v-if="this.selectedCourse.appr == false"
          label="Certificate Status"
          min-width="170px"
          prop="imgurl"
          sortable
          ><template v-slot="{ row }">
            <span
              v-if="row.approval.includes(selectedCourse._id)"
              class="px-4 py-1 mx-1"
              type="primary"
              value="false"
              disabled
            >
              <!-- @click="approves(row)" -->
              <!-- v-model="appr" -->
              Approve
            </span>

            <span
              v-else-if="!row.approval.includes(selectedCourse._id)"
              class="px-4 py-1 mx-1"
              type="danger"
              value="false"
              disabled
            >
              <!-- @click="reject(row)" -->
              <!-- v-model="appr" -->
              Reject
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="Action" min-width="130px">
          <div class="flex items-center">
            <div class="flex items-center mr-4 cursor-pointer">
              <feather-icon
                @click="editModal = true"
                block
                icon="Edit3Icon"
                svgClasses="w-5"
              ></feather-icon>
            </div>
            <div class="flex items-center cursor-pointer">
              <feather-icon icon="Trash2Icon" svgClasses="w-5"></feather-icon>
            </div>
          </div>
        </el-table-column> -->
      </el-table>
    </b-card>
  </div>
</template>

<script>
import Data from "./Data";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import { mapState } from "vuex";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      Data,
      totalTopics: 0,
      userId: [],
      appr: false,
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
      // console.log(this.selectedCourse);
    },
    getTotalTopics() {
      this.selectedCourse.chapter.forEach(
        (x) => (this.totalTopics = x.topic.length)
      );
    },
    getCompletedTopics(user) {
      // console.log(this.attendeesData);
      return this.attendeesData.filter(
        (x) => x.createdBy._user == user && x.status == "completed"
      ).length;
    },
    getTotalPercentage(course) {
      // console.log(this.getCompletedTopics(course));
      // console.log(this.attendeesData);

      return (this.getCompletedTopics(course) / this.totalTopics) * 100;
    },
    getSingleAttendees(user) {
      return this.attendeesData.find((x) => x.createdBy._user == user);
    },
    async approves(row) {
      // console.log(row, "row");

      const result = this.getSingleAttendees(row.userId.id);
      // console.log(result, "res");
      // let payload = {
      //   _id: result.course,
      //   appr: true,
      // };
      this.$swal.fire({
        text: "Certificate Generated",
        icon: "success",
        confirmButtonText: "Ok",
        confirmButtonColor: "#60d394",
        showCancelButton: false,
      });
      const result1 = await this.$store.dispatch("student/editStudents", {
        _id: row.userId.id,
        approve: true,
        approval: this.selectedCourse._id,
      });
      // this.$store.commit("eLearning/selectedCourse", result1);
      // setTimeout(() => {
      //   const userId = [];
      //   this.selectedCourse.attendees.map((x) =>
      //     userId.push(x.createdBy._user)
      //   );
      //   this.$store.dispatch(
      //     "learningTracker/getCourseByStudentId",
      //     {
      //       course: this.selectedCourse._id,
      //       userId: userId,
      //     },
      //     1000
      //   );
      // });
      // const data = await this.$store.dispatch("eLearning/editCourse", payload);
    },
    async reject(row) {
      // console.log(result);
      // console.log(row);
      // this.Adisable = true;
      const result = this.getSingleAttendees(row.userId.id);
      const payload = new FormData();
      payload.append("_id", row.userId.id);
      // payload.append("approve", false);
      payload.append("reject", this.selectedCourse._id);
      this.$swal.fire({
        text: "Certificate Rejected",
        icon: "error",
        confirmButtonText: "Ok",
        confirmButtonColor: "#60d394",
        showCancelButton: false,
      });

      // const data = await this.$store.dispatch("eLearning/getsinglecourse", {
      //   _id: result.course,
      // });
      // console.log(data);
      const result1 = await this.$store.dispatch(
        "student/editStudents",
        payload
      );
    },
  },

  beforeMount() {
    this.getTotalTopics();
  },
  mounted() {
    // console.log(this.course);
    // console.log(this.selectedCourse, "sele");
    // console.log(this.selectedCourse.attendees, "add");
  },
  computed: {
    ...mapState("eLearning", ["selectedCourse"]),
    ...mapState("eLearning", ["course"]),
    ...mapState("learningTracker", ["attendeesData"]),
    ...mapState("student", ["students"]),
  },
};
</script>
<style>
.hidebutton {
  display: none;
}
</style>
